<template >
  <van-row>
    <van-row class="order-info">
      <van-col
        span="18"
        style="margin-top: 5px;"
      >{{generateCustomizeString('createAt')}} {{orderDetailData.created_at}}
      </van-col>
      <van-col
        span="6"
        style="text-align: right;"
        v-if="orderDetailData.is_pick_up === 1"
      >
        <van-tag
          type="primary"
          plain
          style="margin-bottom: 5px;"
        >{{generateCustomizeString('pickUp')}}</van-tag>
      </van-col>
      <van-col
        class="member-info"
        span="24"
        v-if="wechatDetail.headimgurl"
      >
        <van-col>
          <img
            height="40"
            width="40"
            v-lazy="wechatDetail.headimgurl"
            style="padding-top: 3px; margin-left: 5px;"
          >
        </van-col>
        <van-col style="margin-left: 10px; width: 80%;">
          <van-col span="20">{{ generateCustomizeString('wechatName') }} {{wechatDetail.nickname}}
          </van-col>
          <van-col span="20">{{ generateCustomizeString('phone') }} {{orderDetailData.customer_name}}
          </van-col>
        </van-col>
      </van-col>
      <van-col
        class="member-info"
        span="24"
        v-else
      >
        <van-col span="24">{{ generateCustomizeString('wechatName') }} {{wechatDetail.nickname ? wechatDetail.nickname : generateCustomizeString('unbound')}}
        </van-col>
        <van-col span="24">{{ generateCustomizeString('phone') }} {{orderDetailData.customer_name}}
        </van-col>
      </van-col>
    </van-row>

    <van-row style="background-color: #fff; border-radius: 3px; margin-top: 5px;">
      <van-list class="goods-list" v-for="goods in orderProductData" :key="goods.id">
        <van-row class="goods-item" style="display: flex;">
          <van-col span="8" style="text-align: center; margin: auto;">
            <img class="thumbnail" v-lazy="goods.productThumbnailUrl">
          </van-col>
          <van-col span="15" style="margin-left: 5px;">
            <div class="title">{{goods.productTitle}}</div>
            <div class="price">x{{goods.amount}}></div>
          </van-col>
        </van-row>
      </van-list>
    </van-row>

    <van-row style="margin-top: 5px; background: #fff; border-radius: 3px;">
      <van-col span="24">
        <van-cell-group>
          <van-cell
            :title="generateCustomizeString('customerMessage')"
            :label="orderDetailData.message ? orderDetailData.message : generateCustomizeString('none')"
          />
          <van-cell
            :title="generateCustomizeString('paidAt')"
            :value="orderDetailData.paid_at ? orderDetailData.paid_at : generateCustomizeString('none')"
          />
          <!-- <van-cell
            :title="generateCustomizeString('shippingAt')"
            :value="orderDetailData.delivery_at ? orderDetailData.delivery_at : generateCustomizeString('none')"
          /> -->
          <van-cell
            :title="generateCustomizeString('finishedAt')"
            :value="orderDetailData.finished_at ? orderDetailData.finished_at : generateCustomizeString('none')"
          />
        </van-cell-group>
      </van-col>
    </van-row>
  </van-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, Button, Cell, CellGroup, Tag, List } from 'vant'

export default {
  name: 'OrderInfo',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [List.name]: List
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg'
    }
  },
  props: {
    orderDetailData: {
      type: Object,
      default: () => ({})
    },
    wechatDetail: {
      type: Object,
      default: () => ({})
    },
    orderTransaction: {
      type: Array,
      default: () => ([])
    },
    orderFeeDetail: {
      type: Object,
      default: () => ({})
    },
    orderProductData: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    generateCustomizeString
    // onClickLeft() {
    //   this.$router.replace({ name: 'Orders' })
    // }
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
  }
}
</script>

<style lang="less" scoped>
.order-info {
  padding: 10px 10px 20px 10px;
  line-height: 1.2rem;
  border-radius: 5px;
  background: #fff;
}
.member-info {
  margin-top: 5px;
  line-height: 1.5rem;
  border-radius: 3px;
  padding: 0.3rem;
  text-align: left;
  background: #f7f7f7;
  color: #3c3c3c;
}
.order-sender {
  margin-top: 5px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  line-height: 1.5rem;
}
.promotion-info {
  padding-top: 10px;
  text-align: center;
  color: #969799;
}
.goods-list {
    margin: 0 1rem 0 1rem;
    padding-bottom: 8px;
    height: auto;
    padding-top: 10px;
  }
  .goods-item {
    height: auto;
    padding: 5px 0;
  }
  .title {
    font-size: 0.9rem;
    line-height: 1rem;
  }
  .thumbnail {
    background: #f5f5f5;
    width: 5rem;
    height: 5rem;
  }
  .price {
    margin-top: 10px;
    color: #FFA800;
    font-weight: 700;
    line-height: 1rem;
    font-size: 0.9rem;
  }
</style>
